import React from 'react';
import { Link } from 'react-router';
import { BRAND } from '../mock/mockData.js';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="ctr">
        <div className="fg">
          <div>
            <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:8 }}>
              <img src="/assets/totalpe-lockup-transparent-660x160.png" alt="TotalPe" style={{height: '40px', width: 'auto'}}/>
            </div>
            <p style={{ fontSize:'.9rem',color:'rgba(255,255,255,.6)',lineHeight:1.7,maxWidth:280 }}>{BRAND.description}</p>
            <div className="fstores">
              {/*<a href={BRAND.appStoreUrl}  className="fsbtn" target="_blank" rel="noopener noreferrer">🍎 App Store</a>*/}
              <a href={BRAND.playStoreUrl} className="fsbtn" target="_blank" rel="noopener noreferrer">▶ Play Store</a>
            </div>
          </div>
          <div className="fcol">
            <h4>Company</h4>
            <Link to="/about"    className="flink">About Us</Link>
             {/*<Link to="/services" className="flink">Services</Link>
            <a href="/#pricing"  className="flink">Pricing</a>*/}
            <a href="/#faq"      className="flink">FAQ</a> 
          </div>
          <div className="fcol">
            <h4>Legal</h4>
            <Link to="/terms"   className="flink">Terms &amp; Conditions</Link>
            <Link to="/privacy" className="flink">Privacy Policy</Link>
            <Link to="/refund-policy" className="flink">Refund Policy</Link>
          </div>
          <div className="fcol">
            <h4>Contact</h4>
            <a href={`mailto:${BRAND.email}`} className="flink">✉ {BRAND.email}</a>
            <a href={`tel:${BRAND.phone}`}    className="flink">📞 {BRAND.phone}</a>
            <p style={{ fontSize:'.8rem',color:'rgba(255,255,255,.4)',marginTop:8,lineHeight:1.6 }}>
              Mon–Sat 10am–7pm IST
            </p>
          </div>
        </div>
        <div className="fbot">
          <p>© {new Date().getFullYear()} ABNScripts Technologies Pvt. Ltd. All rights reserved. {BRAND.cin}</p>
          {/* <div className="fsoc">
            <a href={BRAND.socials.instagram} className="sbtn" target="_blank" rel="noopener noreferrer">📸</a>
            <a href={BRAND.socials.twitter}   className="sbtn" target="_blank" rel="noopener noreferrer">🐦</a>
            <a href={BRAND.socials.linkedin}  className="sbtn" target="_blank" rel="noopener noreferrer">💼</a>
            <a href={BRAND.socials.youtube}   className="sbtn" target="_blank" rel="noopener noreferrer">▶</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}